module.exports = __webpack_public_path__ + "media/images/thankyou-6ceb68bd9d62e9efab1f5ef1980343c8.png";